/**
 * WhatsApp-style double-tick delivery/read indicator for outgoing messages.
 *
 * Double grey ticks  = delivered (message in server, not yet read)
 * Double blue ticks  = seen (recipient has read the thread)
 *
 * Colors match WhatsApp: #8696a0 for delivered, #53bdeb for read.
 */
export function MessageTicks({ isRead }) {
  const color = isRead ? '#53bdeb' : '#8696a0';
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={isRead ? 'Read' : 'Delivered'}
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
    >
      {/* Left checkmark */}
      <polyline
        points="1,6 3.5,9 9,2"
        stroke={color}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Right checkmark (overlaps left, WhatsApp-style) */}
      <polyline
        points="6.5,6 9,9 17,2"
        stroke={color}
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
